import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/hero-saga/traits';
import { camelizeKeys } from '~/utils/helpers';
import { ResponseTransformer } from '../ResponseTransformer';

const traitApi = {
    index: async () => {
        const { data } = await http.get(`${API_PREFIX}`);

        return camelizeKeys(data);
    },

    create: async (type) => {
        let { data } = await http.get(`${API_PREFIX}/create?type=${type}`);
        data = new ResponseTransformer(data);
        data.camelizeKeys();
        data.transformMainPhases();
        data.transformDefendingSides();

        return data;
    },

    store: async (body, type) => {
        await http.post(`${API_PREFIX}?type=${type}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);
        data = new ResponseTransformer(data);
        data.camelizeKeys();
        data.transformMainPhases();
        data.transformDefendingSides();

        return data;
    },

    update: async (id, body, type) => {
        await http.put(`${API_PREFIX}/${id}?type=${type}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

export default traitApi;

ResponseTransformer.prototype.transformMainPhases = function () {
    this.data.mainPhases = this.data.mainPhases.filter((item) => item !== '').map((item) => ({ id: item, name: item }));
};

ResponseTransformer.prototype.transformDefendingSides = function () {
    this.data.defendingSides = this.data.defendingSides
        .filter((item) => item !== '')
        .map((item) => ({ id: item, name: item }));
};
